import React from 'react'
import { useSelector } from 'react-redux'
import MenuDesktop from '../../components/desktop/menu'
import { getFoodGroup } from '../../selectors'
import { ensureArray } from '../../utils/helper'

const MenuContainer = props => {
    const foodsGrouped = useSelector(state => state.FoodReducer)
    const restaurantInfo = useSelector(state => state.RestaurantReducer)
    const foodGroupInfo = useSelector(getFoodGroup)

    const { logoPath } = restaurantInfo || {}

    return (
        <MenuDesktop
            logoPath={logoPath}
            {...props}
            groups={foodGroupInfo
                .map(el => ({
                    ...el,
                    count: ensureArray(foodsGrouped[el.id]).length,
                }))
                .filter(g => !!g.count)}
        />
    )
}

export default MenuContainer
